import { SAMPLES_ALLOWED_ROLES } from '@/config/samples';
import SamplesPage from '@/pages/Samples/SamplesPage';
import { useAppStore } from '@/stores/app';
import { hasOrgRole } from '@helpers/roles';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/samples/')({
  beforeLoad: ({ context, location }) => {
    if (context.authentication.status === 'PENDING') return;

    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;

    if (context.authentication.status === 'UNAUTHENTICATED') {
      throw redirect({ to: '/login' });
    }

    if (!selectedOrganization) {
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('unauthorized_referrer', location.pathname);
      }
      throw redirect({ to: '/unauthorized' });
    }

    if (context.authentication.status === 'AUTHENTICATED' && context.authentication.user && selectedOrganization?.id) {
      const orgId = selectedOrganization.id;
      const rolesRaw = context.authentication.user.assumed_roles;
      if (!SAMPLES_ALLOWED_ROLES.some(role => hasOrgRole(rolesRaw, orgId, role))) {
        if (typeof window !== 'undefined') {
          sessionStorage.setItem('unauthorized_referrer', location.pathname);
        }
        throw redirect({ to: '/unauthorized' });
      }
    }
  },
  component: SamplesPage,
});
